<div class="headerFlexW pr-4 m-3">
  <div class="content-block">
    <p class="bread-crumbs">Empresas</p>
    <h2 class="">Empresas</h2>
  </div>
  <dx-button *ngIf="usdt.level<3 || usdt.level==4 || usdt.level==5 || usdt.level==6" text="Nueva empresa" icon="plus" type="default" (onClick)="addCompany()"></dx-button>
</div>
<div class="dx-card content-block">
  <div class="responsive-paddings">
    <dx-data-grid #grid [dataSource]="companiesList" keyExpr="id" [allowColumnReordering]="true"
      [masterDetail]="{ enabled: true, template: 'detail', autoExpandAll: false }" showBorders="true">
      <dxo-load-panel [enabled]="true"></dxo-load-panel>
      <dxi-column dataField="companyName" caption="Empresa" sortOrder="asc"></dxi-column>
      <dxi-column dataField="companyPhone" caption="Teléfono"></dxi-column>
      <dxi-column dataField="contactName" caption="Nombre" cellTemplate="nameTemplate"></dxi-column>
      <dxi-column dataField="id" caption="Ver" cellTemplate="viewTemplate"></dxi-column>
      <dxi-column dataField="edit" caption="" cellTemplate="updateTemplate"></dxi-column>
      <div *dxTemplate="let name of 'nameTemplate'">
        {{name.data.contactName}} {{name.data.contactLastName}} {{name.data.contactSecondLastName}}
      </div>
      <div *dxTemplate="let id of 'viewTemplate'">
        <dx-button text="VER" icon="" type="default" [routerLink]="['/dash/company/',id.value]">
        </dx-button>
      </div>
      <div *dxTemplate="let company of 'updateTemplate'">
        <dx-button text="Editar" icon="" type="default" (click)="updateCompany(company)">
        </dx-button>
      </div>
      <div *dxTemplate="let company of 'detail'">
        <div class="flex flex-nowrap flex-space-between datagrid-detailsW">
          <div class="">
            <h2>Datos generales</h2>
            <ul>
              <li>{{company.data.companyName}}</li>
              <li>{{company.data.companyLegalName}}</li>
              <li class="uper-case">RFC: {{company.data.rfc}}</li>
              <li>Tel: {{company.data.companyPhone}}</li>
              <li>Dirección: {{company.data.address.street}}, {{company.data.address.number}},
                {{company.data.address.neighborhood}}</li>
              <li>{{company.data.address.city}}, {{company.data.address.state}}, {{company.data.address.country}},
                {{company.data.address.zip}}
              </li>
            </ul>
          </div>
          <div class="">
            <h2>Datos de contacto</h2>
            <ul>
              <li>{{company.data.contactName}} {{company.data.contactLastName}} {{company.data.contactSecondLastName}}
              </li>
              <li>{{company.data.contactEmail}}</li>
              <li>{{company.data.contactPhone}}</li>
            </ul>
            <!-- <h2>Datos bancarios</h2>
            <ul>
              <li>Banco</li>
            </ul> -->
          </div>
          <div class="">
            <h2>Programas</h2>
            <ul>
              <li *ngFor="let item of company.data.programs">{{item.programName}}, Convenio:
                {{item.agreementNNumber}}</li>
            </ul>
            <h2>Documentos</h2>
            <ul>
              <li>
                <a [href]="company.data.docs.logo" target="_blank" *ngIf="company.data.docs.logo"><i
                    class="far fa-check-square mr-1 brand-color fa-lg"></i> Logo</a>
                <span *ngIf="!company.data.docs.logo"><i class="fal fa-stop fa-lg  mr-1 "></i> Logo</span>
              </li>
              <li>
                <a [href]="company.data.docs.rfc" target="_blank" *ngIf="company.data.docs.rfc"><i
                    class="far fa-check-square mr-1 brand-color fa-lg"></i> RFC</a>
                <span *ngIf="!company.data.docs.rfc"><i class="fal fa-stop fa-lg  mr-1 "></i> RFC</span>
              </li>
              <li>
                <a [href]="company.data.docs.actaConstitutiva" target="_blank"
                  *ngIf="company.data.docs.actaConstitutiva"><i class="far fa-check-square mr-1 brand-color fa-lg"></i>
                  Acta Constitutiva</a>
                <span *ngIf="!company.data.docs.actaConstitutiva"><i class="fal fa-stop fa-lg  mr-1 "></i> Acta
                  Constitutiva</span>
              </li>
              <li>
                <a [href]="company.data.docs.comprobanteDomicilio" target="_blank"
                  *ngIf="company.data.docs.comprobanteDomicilio"><i
                    class="far fa-check-square mr-1 brand-color fa-lg"></i> Comprobante de domicilio</a>
                <span *ngIf="!company.data.docs.comprobanteDomicilio"><i class="fal fa-stop fa-lg  mr-1 "></i>
                  Comprobante de
                  domicilio</span>
              </li>
              <li>
                <a [href]="company.data.docs.id" target="_blank" *ngIf="company.data.docs.id"><i
                    class="far fa-check-square mr-1 brand-color fa-lg"></i> ID</a>
                <span *ngIf="!company.data.docs.id"><i class="fal fa-stop fa-lg  mr-1 "></i> ID</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </dx-data-grid>
  </div>
</div>